<div class="content">
  <glxy-form-field [required]="true">
    <glxy-label>
      {{ 'AUTOMATIONS.COMMON.ACTION' | translate }}
    </glxy-label>
    <glxy-label-hint>
      {{ 'AUTOMATIONS.EDITOR.TASKS.PAUSE_OR_CANCEL_TASK_MANAGER_ACCOUNT.PANEL.HINT' | translate }}
    </glxy-label-hint>
    <mat-radio-group [formControl]="shouldCloseAllTasksControl" required>
      <mat-radio-button [value]="false">
        {{ 'AUTOMATIONS.EDITOR.TASKS.PAUSE_OR_CANCEL_TASK_MANAGER_ACCOUNT.ACTION.PAUSE_ONLY.TITLE' | translate }}
        <extended>
          {{
            'AUTOMATIONS.EDITOR.TASKS.PAUSE_OR_CANCEL_TASK_MANAGER_ACCOUNT.ACTION.PAUSE_ONLY.DESCRIPTION' | translate
          }}
        </extended>
      </mat-radio-button>
      <mat-radio-button [value]="true">
        {{ 'AUTOMATIONS.EDITOR.TASKS.PAUSE_OR_CANCEL_TASK_MANAGER_ACCOUNT.ACTION.PAUSE_AND_CLOSE.TITLE' | translate }}
        <extended>
          {{
            'AUTOMATIONS.EDITOR.TASKS.PAUSE_OR_CANCEL_TASK_MANAGER_ACCOUNT.ACTION.PAUSE_AND_CLOSE.DESCRIPTION'
              | translate
          }}
        </extended>
      </mat-radio-button>
    </mat-radio-group>
  </glxy-form-field>
</div>
